import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import AssignedCFIsGrid from '../../../features/dealer/assigned-cfis-grid/components/AssignedCFIsGrid';

export default function AssignedCFIsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Assigned Providers')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<AssignedCFIsGrid />
			</div>
		</React.Fragment>
	)
} 
